module.exports = __webpack_public_path__ + "static/ukb-9f385e4524af903e47aa7007c6ad9adc.png";